module.exports = __webpack_public_path__ + "static/media/LGP-180x180.8daa79f9.png";